module.exports = __webpack_public_path__ + "img/scene-community.f2b5b1db.jpg";